export const light = {
  name: 'light',

  // Background global
  background: '#fff',
  color: '#fff',
  headerColorResponsive: '#fff',

  // Search
  backgroundInput: '#2c2f33',
  inputIcon: '#fff',

  // Buttons [ states, countries]
  optionsContent: 'rgba(72, 114, 199, 0.6)',
  optionsContentText: '#fff',

  // Status
  listInformationText: '#000',
  informationTitle: '#727573',

  // Header
  headerColor: '#006daa',
  headerText: '#fff',
  backgroundHeader: 'rgba(0, 0, 0, 0.5)',

  // Settings
  SettingsHeader: '#fff',

  // Dropdown
  DropdownBackground: '#fff',
  DropdownItems: '#000',

  // Home [ RowItems and RowContainer]
  rowBackground: 'rgba(0, 109, 170, 0.9)',
  rowBorder: '#b9d6f2',
  rowButton: '#061a40',
  rowArrowColor: '#fff',

  // Configurações [ Componente absoluto ]
  backgroundSettings: '#f5f5f5',
  settingsText: '#000',
  borderDivisor: '#000',
  settingsClose: '#000',

  // Sobre o coronaviurs page
  paragrafos: '#000',
};

export const dark = {
  name: 'dark',

  // Background global
  background: '#2c2f33',
  color: '#F9F8F8',
  headerColorResponsive: '#fff',

  // Search
  backgroundInput: '#F9F8F8',
  inputIcon: '#000',

  // Buttons [ states, countries]
  optionsContent: '#F9F8F8',
  optionsContentText: '#000',

  // Status [ states, countries]
  listInformationText: '#F9F8F8',
  informationTitle: '#F9F8F8',

  // Header
  headerColor: '#212121',
  headerText: '#fff',
  backgroundHeader: 'rgba(0, 0, 0, 0.5)',

  // Settings
  SettingsHeader: '#fff',

  // Dropdown
  DropdownBackground: '#212121',
  DropdownItems: '#fff',

  // Home [ RowItems and RowContainer]
  rowBackground: '#212121',
  rowBorder: '#fff',
  rowButton: '#fff',
  rowArrowColor: '#000',

  // Configurações [ Componente absoluto ]
  backgroundSettings: '#212121',
  settingsText: '#fff',
  borderDivisor: '#fff',
  settingsClose: '#fff',

  // Sobre o coronaviurs page
  paragrafos: '#fff',
};
